import React from 'react';
import { AllEntityTypes } from 'models/ComunicationHub';
import { CloseIcon, DoneIcon } from 'components/common/icons';
import { Button, Col, CommunicationHubEntityType, Form, FormInstance, Row, Select } from 'components';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { RelationEntity } from './relationEntity';
import { useRelation } from './useRelation';

const { Item } = Form;

export interface IRelation {
  form: FormInstance;
  entity: CommunicationHubEntityType;
  relationList: Record<string, any>[];
  onSave: (relation: any) => void;
  onRemove?: (relation: any) => void;
  onEdit?: (id: string, type: string) => void;
}

export const RelationForm = (props: IRelation) => {
  const { hasAccess } = useAccessControl();
  const { form, relationList, entity, onSave, onRemove } = props;
  const { onRelationCancel, onRelationSave, isChanged } = useRelation({ form, entity, relationList, onSave, onRemove });
  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Item name="relationType" label={'Relation Type'}>
          <Select
            onChange={() => {
              form.resetFields(['relationEntity']);
            }}
            options={Object.values(AllEntityTypes).filter(
              (i) =>
                hasAccess(i.permission) && i.value !== entity && !(entity === 'PURCHASE_REQUEST' && i.value === 'DEAL')
            )}
            size={'large'}
          />
        </Item>
      </Col>
      <Col span={12}>
        <Item noStyle shouldUpdate={(prev, curr) => prev.relationType !== curr.relationType}>
          {({ getFieldValue }) => {
            const entity = getFieldValue('relationType');
            return <RelationEntity entity={entity} relations={relationList} />;
          }}
        </Item>
      </Col>
      <Col span={24}>
        <Row gutter={4} justify={'end'}>
          <Col>
            <Button
              disabled={!isChanged}
              color="default"
              variant="filled"
              onClick={onRelationCancel}
              icon={<CloseIcon />}
            />
          </Col>
          <Col>
            <Button onClick={onRelationSave} disabled={!isChanged} type={'primary'} icon={<DoneIcon />} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
